<ng-template #passedValue><ng-content></ng-content></ng-template>
@if (type === 'link' && isUrlLink) {
    <a
        [href]="url"
        [attr.target]="isCurrentUrl ? '_self' : '_blank'"
        type="{{ type }}"
        class="btn btn-outline"
        [ngClass]="{
            'btn-primary': color === 'primary',
            'btn-secondary': color === 'secondary',
        }"
    >
        <div>
            <span><ng-container *ngTemplateOutlet="passedValue"></ng-container></span><span></span>
        </div>
    </a>
}

@if (type === 'link' && !isUrlLink) {
    <a
        [replaceUrl]="replaceUrl"
        [skipLocationChange]="skipLocationChange"
        [routerLink]="url"
        type="{{ type }}"
        class="btn btn-outline"
        [ngClass]="{
            'btn-primary': color === 'primary',
            'btn-secondary': color === 'secondary',
        }"
    >
        <div>
            <span><ng-container *ngTemplateOutlet="passedValue"></ng-container></span><span></span>
        </div>
    </a>
}

@if (type !== 'link') {
    <button
        [disabled]="disabled"
        type="submit"
        (click)="onClick()"
        [replaceUrl]="replaceUrl"
        [skipLocationChange]="skipLocationChange"
        [routerLink]="url"
        class="btn btn-outline"
        [ngClass]="{
            'btn-primary': color === 'primary',
            'btn-secondary': color === 'secondary',
        }"
    >
        <div>
            <span><ng-container *ngTemplateOutlet="passedValue"></ng-container></span><span></span>
        </div>
    </button>
}
